import React from 'react';
import { Link } from 'react-router-dom';
import { ReportsTypeArray } from '../../../constant/reports/reportsType';
import './ListCard.scss';

type AppProps = {
  client_code?: number;
  listTitle: string;
  list: [] | ReportsTypeArray[];
  company_name?: string;
}

const ListCard = ({
  listTitle,
  list,
  client_code,
  company_name
}: AppProps) => {

  const renderReportList = () => {
     let isActive:any=[];
     let notActive:any=[]
    list?.map((item:any)=>{
      if(item?.coming_soon===1){
        notActive.push(item)
      }
      else{
        isActive.push(item)
      }
    })

    const finalList = [...isActive,...notActive]?.map((element: any) => {
    
      const finalLink = {
        pathname: `/reports/${ client_code }/${ element?.front_end_route }`,
        state: { client_code, company_name }
      }

      return (
        <li key={element?.key}>
          <Link
            to={finalLink}
            style={element?.comingSoon ? { pointerEvents: "none" } : undefined}
          >
            <div className="d-flex justify-content-between">
              <div className={`${ element?.coming_soon && 'coming-soon-font' }`}>{element.menu_name}</div>
              {
                element?.coming_soon ?
                  <div className="status-coming-soon ">Request Access</div> :
                  <div className="status-view pointer">View</div>
              }
            </div>
          </Link>
        </li>
      )
    });

    return finalList;
  }

  return (
    <div className='list-card-container'>
      <div className="list-card-header">
        {listTitle}
      </div>
      <ul className="list-card-element">
        {renderReportList()}
      </ul>
    </div>
  )
};

export default ListCard;